
import {Component, Vue, Watch} from 'vue-property-decorator';
import {commitAddNotification} from '@/store/main/mutations';
import {IForm} from '@/interfaces/form';
import {dispatchGetFormCategories, dispatchGetForms, dispatchUpdateForm} from '@/store/admin/actions';
import {readAdminForm, readFormCategories} from '@/store/admin/getters';
import AlertDialogWrapper from '@/components/dialogs/AlertDialogWrapper.vue';
import AlertDialogFrame from '@/components/dialogs/AlertDialogFrame.vue';
import {rules} from '@/utils';
import {dispatchGetForm} from '@/store/main/actions';

@Component({
  components: {AlertDialogFrame, AlertDialogWrapper},
})
export default class FormEdit extends Vue {
  private FETitle: string = `${this.$t('crud.edit')} ${this.$t('form')}`;
  private valid: boolean = true;
  private formIDValue: number = 0;
  private currentForm: IForm = {} as IForm;
  private rules: any = rules;

  private alertDialog: any = null;
  private alertHeader: string = '';
  private alertMessage: string = '';

  private get formID() {
    return this.formIDValue;
  }

  private set formID(value: number) {
    this.formIDValue = value;
  }

  private get formCategories() {
    return readFormCategories(this.$store);
  }

  public async loadMountSettings() {
    // const cForm = {} as IForm;
    // Object.assign(cForm, this.form);
    // this.currentForm = {
    //   id: cForm.id,
    //   title: cForm.title,
    //   version: cForm.version,
    //   path: cForm.path,
    //   form_setting: cForm.form_setting,
    // } as IForm;
  }

  public cancel() {
    this.$router.back();
  }


  public async editForm() {
    const form: any = this.$refs.form_update_form;
    if (!form.validate()) {
      return;
    }
    if (!this.form) {
      commitAddNotification(this.$store, {
        content: 'The form cannot be edited',
        color: 'warning',
      });
      return;
    }

    const formControls = this.form?.form_setting?.form_data?.controls;

    if (formControls) {
      const checkFields = await Object.values(formControls).filter((e: any) => e?.name === '')
        .map((e: any) => e?.label);
      if (checkFields.length > 0) {
        this.alertHeader = 'Atenção!';
        this.alertMessage = `O formulário possui alguns controles sem o campo 'name' definido:<br/>
                             Controles: <pre class="text-break">${JSON.stringify(checkFields)}</pre><br/>
                             <b>É altamente recomendável que todos os controles possuam um nome (rótulo)
                             para padronização dos dados.</b><br/><br/>
                             Deseja continuar?`;
        const resp = await this.alertDialog.open({width: 600}).then((result) => {
          return result;
        });
        if (!resp) {
          return;
        }
      }
      const controls = Object.values(formControls);
      let checkDuplicatedNames = await controls.map((e: any) => e?.name);
      checkDuplicatedNames = checkDuplicatedNames.filter((e: any, i) => checkDuplicatedNames.indexOf(e) !== i);

      if (checkDuplicatedNames.length > 0) {
        this.alertMessage = `O formulário possui alguns controles com o campo 'name' duplicados:<br/>
                             Controles: <pre class="text-break">${JSON.stringify(checkDuplicatedNames)}</pre><br/>
                             <b>É altamente recomendável que todos os controles possuam um nome (rótulo) único.</b>
                             <br/><br/>
                             <b>Se você continuar, é possível haver inconsistências nos dados registrados.</b><br/>
                             Deseja realmente continuar?`;
        const resp = await this.alertDialog.open({width: 600}).then((result) => {
          return result;
        });
        if (!resp) {
          return;
        }
      }
      // // @ts-ignore
      // const controlsOldForm = Object.keys(this.form?.form_setting?.form_data?.controls);
      // // @ts-ignore
      // const controlsCurrentForm = Object.keys(this.currentForm?.form_setting?.form_data?.controls);
      //
      // if (controlsCurrentForm && controlsOldForm) {
      //   console.log(controlsCurrentForm);
      //   console.log(controlsOldForm);
      // }
      // return;

      const dataToSave: IForm = {
        id: this.currentForm.id,
        title: this.currentForm.title,
        is_enabled: this.currentForm.is_enabled,
        form_setting: JSON.parse(JSON.stringify(this.currentForm.form_setting)),
        form_category_id: this.currentForm.form_category_id,
      };
      await dispatchUpdateForm(this.$store, dataToSave);
      this.$router.push('/main/admin/forms/');
    }
  }


  public get form() {
    return readAdminForm(this.$store)(+this.formID);
  }

  public async mounted() {
    await dispatchGetFormCategories(this.$store);
    this.alertDialog = this.$refs.alert_dialog;
    this.formID = this.$router.currentRoute.params.id as unknown as number;
    await dispatchGetForm(this.$store, this.formID);
    this.currentForm = {...this.form} as IForm;
    // this.loadMountSettings();
  }

  // public beforeRouteEnter(to, from, next) {
  //   this.formID = to.params.id;
  //   this.loadMountSettings();
  //   next();
  // }

  public beforeRouteLeave(to, from, next) {
    this.$forceUpdate();
    this.currentForm = {} as IForm;
    this.$destroy();
    next();
  }
}
